export const locale = {
    lang: 'tr',
    data: {
      'TOOLBAR': {
          'PERFIL': 'Benim profilim',
          'INBOX': 'Gelen kutusu',
          'LOGOUT': 'Çıkış Yap',
          'ADMIN': 'olarak giriş yapıldı:',
          'LOGIN':'Giriş yap: ',
          'GOPROFILE':'Profile',
          'CITIES':{
            '0':'',
            '1':'Meksika şehri',
            '2':'San salvador',
            '3':'Hong kong',
            '4':'Singapure',
            '5':'Istanbul',
            '6':'Victoria',
            '8':'Meksika şehri',
            '11':'São Paulo',
            '14':'Meksika şehri',
            '15':'Madrid',
            'IZZI':'Meksika şehri',
            'MX':'Meksika şehri',
            '19':'Meksika şehri',
        },
        'LOGOUT_MODAL': {
          'TEXTO': 'Oturumu kapattığınızdan emin misiniz?',
          'SI': 'Evet',
          'NO': 'Hayır'
        }
      }
    }
};
